import {UseQueryResult, useQuery} from "@tanstack/react-query";

import {eatClubClient} from "@globals/config/apiClient";
import {PaymentGroup} from "@globals/types/PaymentGroup";

function fetchPaymentGroups(): Promise<PaymentGroup[]> {
  return eatClubClient
    .get("/member/api/payment-groups/")
    .then((response) => response.data)
    .catch(({response}) => {
      const error = {
        status: response?.status,
        message: response?.data?.message,
      };
      throw error;
    });
}

export default function usePaymentGroups(): UseQueryResult<
  PaymentGroup[],
  Error
> {
  return useQuery<PaymentGroup[], Error>({
    queryKey: ["payment-groups"],
    queryFn: fetchPaymentGroups,
  });
}
